import React from "react"
import {
  LevelCompleteBannerContainer,
  LevelCompleteBannerHeader,
  CheckIconWrapper,
  LevelCompleteBannerTitle,
  LevelCompleteBannerMessage,
} from "./Styles/LevelCompleteBanner.styles"
import { LEVEL_COMPLETE_BANNER } from "./utils/constants/bannerMessages"

const LevelCompleteBanner = ({ levelName, completionDate }) => {
  let formattedDate = ""
  if (completionDate) {
    // Parse date string (YYYY-MM-DD) without timezone influence
    const [year, month, day] = completionDate.split("-")

    const paddedMonth = month.padStart(2, "0")
    const paddedDay = day.padStart(2, "0")
    formattedDate = `${paddedMonth}/${paddedDay}/${year}`
  }

  const isQualifying = levelName?.toLowerCase().includes("qualifying")

  const title = isQualifying
    ? LEVEL_COMPLETE_BANNER.QUALIFYING.title
    : LEVEL_COMPLETE_BANNER.DEFAULT.getTitle(levelName)

  const message = isQualifying
    ? LEVEL_COMPLETE_BANNER.QUALIFYING.getMessage(formattedDate)
    : LEVEL_COMPLETE_BANNER.DEFAULT.getMessage(levelName, formattedDate)

  return (
    <LevelCompleteBannerContainer>
      <LevelCompleteBannerHeader>
        <CheckIconWrapper>
          <svg width="16" height="11" viewBox="0 0 16 11" fill="none">
            <path
              d="M1 5L6 10L15 1"
              stroke="#2CA24B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </CheckIconWrapper>
        <LevelCompleteBannerTitle>{title}</LevelCompleteBannerTitle>
      </LevelCompleteBannerHeader>
      <LevelCompleteBannerMessage>{message}</LevelCompleteBannerMessage>
    </LevelCompleteBannerContainer>
  )
}

export default LevelCompleteBanner
